<div #container></div>

<p-sidebar [(visible)]="updateAvailable"
           (onHide)="cancelUpdate()"
           [showCloseIcon]="false"
           [appendTo]="container"
           [baseZIndex]="200"
           [modal]="false"
           position="top"
           styleClass="auto-update-sidebar">

    <div class="auto-update-banner-content">
        <p class="auto-update-text">
            New version of the app is available. Please save your changes and reload the page, otherwise
            the application will be reloaded automatically in {{ autoUpdateRemainingSeconds }} seconds.
        </p>
        <button pButton
                type="button"
                icon="pi pi-refresh"
                label="Reload the app"
                (click)="applyUpdate()">
        </button>
    </div>
</p-sidebar>